import React, { useState, useEffect } from 'react'
import {Tag, Tooltip,Form,Select,Input, Popconfirm, message, Modal } from 'antd'
import 'moment/locale/zh-cn'
import _lodash,{get,isNumber} from 'lodash'
import styles from './index.module.less'
import { ajaxApi,ajaxApiGet } from '@/server/index'
import { getParmUrl } from '@/public/utils'
import common from '@/public/common'
import {DownOutlined, QuestionCircleOutlined, UpOutlined} from '@ant-design/icons'
import {periodicDataConversion} from '../utils'
import {validValue} from '../../../public/utils'
import Pdf from '../../../static/img/pdf_file.png'
import moment from 'moment'
import { deepCopy } from "../addinfomation/utils";
import { itemNameTooltipMap, itemSeriesTooltipMap } from '../addinfomation/constant'
const CommodityInformation = (props) => {
  const {detailsdata} = props
  const [detailsData, setdetailsData] = useState(sessionStorage.getItem('detailsData')?JSON.parse(sessionStorage.getItem('detailsData')):'' || detailsdata)
  const [placeOrigin, setplaceOrigin] = useState([])
  const [categoryid, setCategoryid] = useState(getParmUrl('categoryid'))
  const [showCreateCompanyDetail, setShowCreateCompanyDetail] = useState(false)
  const [info, setInfo] = useState([]);
  const [form] = Form.useForm()
  const [Lucenform] = Form.useForm()
  //根据缓存获取花色列表
  function getCurrencyList() {
    const session =sessionStorage.getItem('detailsData')? JSON.parse(sessionStorage.getItem('detailsData')).extend_color_properties:''
    ajaxApiGet({
      url: common.scpUrl + "item/category-attrs?category=3",
    }).then((res) => {
      if (res.data.code === 200) {
        if (session && session.length > 0) {
          if (session[0].color == '无色') {
            res.data.data.extra_attrs = res.data.data.extra_attrs.filter(
              (item) => item.english_name !== "ContactsType"&&item.english_name !== "ContactDiscardCycle"&&item.english_name!=='ColoredDiameter'
            );
          } else {
            res.data.data.extra_attrs = res.data.data.extra_attrs.filter(
              (item) => item.english_name !== "ContactsType"&&item.english_name !== "ContactDiscardCycle"
            );
          }
          let data = session.map((item, index) => {
            let copyData=deepCopy(res.data.data.extra_attrs)
            copyData[0].color = item.color
            copyData[0].colorId =index
            form.setFieldValue(index, item);
            return copyData;
          });
          data.map(item => {
            item.map(ele => {
              ele.english_name=ele.english_name.toLowerCase()
            })
          })
          Lucenform.setFieldsValue(session[0])
          setInfo(data);
        } else {
          let data = res.data.data.extra_attrs;
          data[0] = { ...data[0], color: "", colorId: 0 };
          setInfo([data]);
        }
      }
    });
  }
  // 原厂地
  const getPlaceOrigin = async () => {
    let res = await ajaxApi({
      url: common.scpUrl + 'item/query-origin-place',
      params: {}
    })
    if (res.status && res.data) {
      setplaceOrigin(res.data.data || [])
    } else {
      setplaceOrigin([])
    }
  }

  useEffect(() => {
    setdetailsData(JSON.parse(sessionStorage.getItem('detailsData')))
    getCurrencyList()
    getPlaceOrigin()
  }, [])

  const originPlacefunc = (value) => {
    if (value) {
      let name = ''
      placeOrigin.forEach((item2) => {
        if (value === item2.code) {
          name = item2.name
        }
      })

      return name
    } else {
      return '--'
    }
  }

  const getRequiredIocn=()=>{
    return <span className={styles.required}>*</span>
  }
  const isCrossborder = detailsData.item_info.is_cross_border === 1
  const categoryId = getParmUrl('categoryid')
  return (
    <div>
      <div style={{ display: 'flex', border: '1px solid #d9d9d9' }}>
        <div style={{ width: '100%' }}>
          <div className={styles.total_title}>
            <span className={styles.titles}>基础信息</span>
          </div>
          <div className={styles.public_info}>
            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                {/* <span className={styles.required}>{!['3','5','7','21'].includes(categoryid)&&'*'}</span> */}
                {!['3', '5', '7', '21'].includes(categoryId) && <span className={styles.required}>*</span>}
                {itemNameTooltipMap.get(categoryId, isCrossborder) && <Tooltip title={itemNameTooltipMap.get(categoryId, isCrossborder)}>
                  <QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/>
                </Tooltip>}
                商品名称：
              </span>

              <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.item_name : '--'}</span>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>商品品牌：
              </span>
              <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.brand_name : '--'}</span>
              {_lodash.get(detailsData,'item_info.new_brand_flag') && <Tag color={'orange'} style={{marginLeft: 8}}>新</Tag>}
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>{ ['3','5','7','21'].includes(categoryid)&&'*'}</span>
                <Tooltip title={itemSeriesTooltipMap.get(categoryId, isCrossborder)}><QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/></Tooltip>
                商品系列：
              </span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info.item_series ? detailsData.item_info.item_series : '-'}</span>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>类型：
              </span>

              <span className={styles.public_span_style}>{get(detailsData,'item_info.item_color_type_name')||''}</span>

            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>规格：
              </span>
              <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.spec : '--'}</span>
              <span>{detailsData ? detailsData.item_info.spec_unit : ''}</span>
            </section>

            <section className={styles.publicsection} style={{display: getParmUrl('categoryid') === '3' ? 'block' : 'none'}}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>商品材质：
              </span>
              <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.item_material : '--'}</span>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>产品有效期：
              </span>
              {
                detailsData && detailsData.item_info.is_long_expiration ? '长期' : <span> <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.item_useful_life : '--'}</span>
                  <span>{detailsData ? detailsData.item_info.useful_unit : ''}</span></span>
              }

            </section>

            {detailsData.item_info.category_id === 3 ? <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>是否散光片：
              </span>
              <span className={styles.public_span_style}>{detailsData ? (detailsData.item_info.is_customed ? '是' : '否') : '--'}</span>
            </section> : null}
            {(detailsData.item_info.category_id === 3 || detailsData.item_info.category_id === 5 || detailsData.item_info.category_id === 7) && detailsData.item_info.is_cross_border === 0 ? <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>是否进口：
              </span>
              <span className={styles.public_span_style}>{detailsData ? (detailsData.item_info.is_import ? '是' : '否') : '--'}</span>
            </section> : null}
            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                是否赠品：
              </span>
              <span className={styles.public_span_style}>{detailsData && isNumber(detailsData.item_info.is_gift) ? (detailsData.item_info.is_gift ? '是' : '否') : '--'}</span>
            </section> 
            {(detailsData.item_info.category_id === 3 || detailsData.item_info.category_id === 5 || detailsData.item_info.category_id === 7) && detailsData.item_info.is_cross_border === 0 ? <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>产地：
              </span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info.origin_place ? detailsData.item_info.origin_place : '--'}</span>
            </section> : null}
            {(detailsData.item_info.category_id === 3 || detailsData.item_info.category_id === 5 || detailsData.item_info.category_id === 7) && detailsData.item_info.is_cross_border === 0 ? <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>生产方式：
              </span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info.produce_type ? (detailsData.item_info.produce_type == 'selfproduction' ? '自行生产' : '委托生产') : '--'}</span>
            </section> : null}
            {(detailsData.item_info.category_id === 3 || detailsData.item_info.category_id === 5 || detailsData.item_info.category_id === 7) && detailsData.item_info.is_cross_border === 0 ? <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>医疗器械名称：
              </span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info.medical_name ? detailsData.item_info.medical_name : '--'}</span>
            </section> : null}
            {(detailsData.item_info.category_id === 3 || detailsData.item_info.category_id === 5 || detailsData.item_info.category_id === 7) && detailsData.item_info.is_cross_border === 0 ? <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>主要功能：
              </span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info.main_function ? detailsData.item_info.main_function : '--'}</span>
            </section> : null}
            {(detailsData.item_info.category_id === 3 || detailsData.item_info.category_id === 5 || detailsData.item_info.category_id === 7) && detailsData.item_info.is_cross_border === 0 ? <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>存储要求：
              </span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info.storages ? detailsData.item_info.storages : '--'}</span>
            </section> : null}
            {(detailsData.item_info.category_id === 3 || detailsData.item_info.category_id === 5 || detailsData.item_info.category_id === 7) && detailsData.item_info.is_cross_border === 0 ? <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>型号及规格：
              </span>
              <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.pro_model : '--'}</span>
            </section> : null}
            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>单品重量：
              </span>
              <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.weight + '（Kg）' : '--'}</span>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>箱规：
              </span>
              <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.packing_specification + '个/箱' : '--'}</span>
            </section>

            <section className={styles.publicsection} hidden={get(detailsData,'item_info.is_cross_border') === 1}>
                  <span className={styles.publlictitle}>
                    <span className={styles.required}>*</span>生产企业：
                  </span>
              <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.create_company : '--'}</span>
              {_lodash.get(detailsData,'item_info.new_create_company_flag') && <Tag color={'orange'} style={{marginLeft: 8}}>新</Tag>}
              <span onClick={() => setShowCreateCompanyDetail(!showCreateCompanyDetail)}>
                {showCreateCompanyDetail ? <UpOutlined style={{marginRight: 8}}/> : <DownOutlined style={{marginRight: 8}}/>}
                    {/* <Icon type={showCreateCompanyDetail ? 'up' : 'down'} /> */}
                 <span style={{color: 'red'}}>{showCreateCompanyDetail ? '收起' : '展开'}详情</span>
              </span>
              <div style={{paddingLeft: 140}} hidden={!showCreateCompanyDetail}>
                <div style={{margin: '8px'}}>
                  <span style={{width: 68, textAlign: "right", display: 'inline-block', marginRight: 8}}>住所: </span>
                  {_lodash.get(detailsData,'create_company_bo.residence','--') || '--'}
                </div>
                <div style={{margin: '8px'}}>
                  <span style={{width: 68, textAlign: "right", display: 'inline-block', marginRight: 8}}>电话: </span>
                  {_lodash.get(detailsData,'create_company_bo.vender_tel','--') || '--'}
                </div>
                <div style={{margin: '8px'}}>
                  <span style={{width: 68, textAlign: "right", display: 'inline-block', marginRight: 8}}>生产地址: </span>
                  {_lodash.get(detailsData,'create_company_bo.vender_address','--') || '--'}
                </div>
              </div>
            </section>
          {detailsData&&detailsData.item_info&&detailsData.item_info.category_id && detailsData.item_info.category_id == 3&&  <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>更换周期：
              </span>
                {detailsData&&detailsData.contact_property&&detailsData.contact_property.change_cycle&&
                  <span className={styles.public_span_style}>
                  {detailsData.contact_property.change_cycle == 'Day' && '日抛'}
                  {detailsData.contact_property.change_cycle == 'Week' && '周抛'}
                  {detailsData.contact_property.change_cycle == 'Fortnight' && '双周抛'}
                  {detailsData.contact_property.change_cycle == 'Month' && '月抛'}
                  {detailsData.contact_property.change_cycle == 'TwoMonths' && '双月抛'}
                  {detailsData.contact_property.change_cycle == 'Quarter' && '季抛'}
                  {detailsData.contact_property.change_cycle == 'SixMonths' && '半年抛'}
                  {detailsData.contact_property.change_cycle == 'Year' && '年抛'}
                  </span>
                  }
            </section>}
          </div>

          {/*品牌信息*/}
          <div
            className={styles.total_title}
            hidden={!validValue(detailsData, 'brand_qualification.brand_name')}
          >
            <span className={styles.titles}>品牌信息</span>
          </div>
          <div
            className={styles.public_info}
          >
            <section className={styles.publicsection} hidden={!validValue(detailsData,'brand_qualification.chinese_mainland_regist_flag')}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>
                中国大陆是否注册商标：
              </span>
              <span className={styles.public_span_style}>{get(detailsData,'brand_qualification.chinese_mainland_regist_flag') === 1 ? '是' : '否'}</span>
            </section>

            <section className={styles.publicsection} hidden={!validValue(detailsData, 'brand_qualification.brand_type')}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>{get(detailsData,'brand_qualification.chinese_mainland_regist_flag') === 1 && '*'}</span>
                商标类别：
              </span>
              <span className={styles.public_span_style}>{get(detailsData,'brand_qualification.brand_type','--')}</span>
            </section>

            <section className={styles.publicsection} hidden={!validValue(detailsData,'brand_qualification.brand_register')}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>{get(detailsData,'brand_qualification.chinese_mainland_regist_flag') === 1 && '*'}</span>
                商标注册人：
              </span>
              <span className={styles.public_span_style}>{get(detailsData,'brand_qualification.brand_register','--')}</span>
            </section>

            <section className={styles.publicsection} hidden={!validValue(detailsData,'brand_qualification.begin_time')}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>{get(detailsData,'brand_qualification.chinese_mainland_regist_flag') === 1 && '*'}</span>
                有效日期：
              </span>
              <span className={styles.public_span_style}>
                {
                  get(detailsData,'brand_qualification.begin_time') ?
                    moment(get(detailsData,'brand_qualification.begin_time')).format('YYYY-MM-DD') + ' - ' +
                    moment(get(detailsData,'brand_qualification.end_time')).format('YYYY-MM-DD') : '--'
                }
              </span>
            </section>

            <section className={styles.publicsection} hidden={!validValue(detailsData,'brand_qualification.qua_code')}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>{get(detailsData,'brand_qualification.chinese_mainland_regist_flag') === 1 && '*'}</span>
                资质证号：
              </span>
              <span className={styles.public_span_style}>{get(detailsData,'brand_qualification.qua_code', '--')}</span>
            </section>

            <section
              className={styles.publicsection}
              style={{display: 'flex'}}
              hidden={!validValue(detailsData,'brand_qualification.files')}
            >
              <span className={styles.publlictitle}>
                <span className={styles.required}>{get(detailsData,'brand_qualification.chinese_mainland_regist_flag') === 1 && '*'}</span>
                商标附件：
              </span>
              <span
                className={styles.public_span_style}
                style={{flex: 1}}
              >{
                (get(detailsData,'brand_qualification.files') || []).map(el => <img onClick={() => window.open(el,'_target')} src={el.includes('.pdf') ? Pdf : el} height={100} width={100} style={{margin: '0 8px 8px 0'}}/>)}
              </span>
            </section>
          </div>

          {detailsData && detailsData.item_info.is_cross_border === 1
            ? <span>
              <div className={styles.total_title}>
                <span className={styles.titles}>海淘信息</span>
              </div>

              <div className={styles.public_info}>
                <section className={styles.publicsection}>
                  <span className={styles.publlictitle}>
                    <span className={styles.required}>*</span>商品英文名称：
                  </span>
                  <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.english_name : '--'}</span>
                </section>

                {/* <section className={styles.publicsection}>
                  <span className={styles.publlictitle}>
                    <span className={styles.required}>*</span>物流服务：
                  </span>
                  <span className={styles.public_span_style}>{detailsData ? (detailsData.item_info.logistics_service === 'kjt' ? '香港顺丰' : detailsData.item_info.logistics_service === 'xgsf' ? '上海跨境通' : '其他') : '--'}</span>
                </section> */}

                <section className={styles.publicsection}>
                  <span className={styles.publlictitle}>
                    <span className={styles.required}>*</span>生产企业：
                  </span>
              <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.create_company : '--'}</span>
                  {_lodash.get(detailsData,'item_info.new_create_company_flag') && <Tag color={'orange'} style={{marginLeft: 8}}>新</Tag>}
                  <span onClick={() => setShowCreateCompanyDetail(!showCreateCompanyDetail)}>
                {showCreateCompanyDetail ? <UpOutlined style={{marginRight: 8}}/> : <DownOutlined style={{marginRight: 8}}/>}
                    {/* <Icon type={showCreateCompanyDetail ? 'up' : 'down'} /> */}
                    <span style={{color: 'red'}}>{showCreateCompanyDetail ? '收起' : '展开'}详情</span>
              </span>
              <div style={{paddingLeft: 140}} hidden={!showCreateCompanyDetail}>
                <div style={{margin: '8px'}}>
                  <span style={{width: 68, textAlign: "right", display: 'inline-block', marginRight: 8}}>住所: </span>
                  {_lodash.get(detailsData,'create_company_bo.residence','--') || '--'}
                </div>
                <div style={{margin: '8px'}}>
                  <span style={{width: 68, textAlign: "right", display: 'inline-block', marginRight: 8}}>电话: </span>
                  {_lodash.get(detailsData,'create_company_bo.vender_tel','--') || '--'}
                </div>
                <div style={{margin: '8px'}}>
                  <span style={{width: 68, textAlign: "right", display: 'inline-block', marginRight: 8}}>生产地址: </span>
                  {_lodash.get(detailsData,'create_company_bo.vender_address','--') || '--'}
                </div>
              </div>
            </section>

                <section className={styles.publicsection}>
                  <span className={styles.publlictitle}>
                    <span className={styles.required}>*</span>产地：
                  </span>
                  <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.origin_place : '--'}</span>
                </section>
              </div>
            </span>
            : null}

          {detailsData && detailsData.item_info.category_id === 3
            ?
            <span>
              {
                get(detailsData, 'item_info.item_color_type_name')&&get(detailsData, 'item_info.item_color_type_name').includes('彩色') ?
                  <section style={{ marginLeft: '17%' }}>
                    <div className={styles.total_title} style={{paddingLeft:0}}  >
                    <span className={styles.titles}>SKU</span>
                </div>
                    <div style={{ margin: '10px 0 2px' }}>
                    <span style={{color:'red'}}>*</span>
                      花色
                    </div>
                    {detailsData.extend_color_properties.map(item => <span key={item.color}  className={styles.design_color}>{item.color}</span>  ) }
                   <div>    
                    <section>
                      <div >
                        <span className={styles.required}>*</span>光度：
                      </div>
                      <div style={{display: 'flex', flexWrap:'wrap', width: '65%', verticalAlign: 'middle'}}>
                        {detailsData && detailsData.degrees.length !== 0 ? (
                          detailsData.degrees.map((item, index) => {
                            if (item) {
                              return (
                                <span key={index}>{item + '/'}</span>
                              )
                            } else {
                              return '--'
                            }
                          })
                        ) : '--'}
                      </div>
                    </section>
                    </div>
                    <div className={styles.total_title} style={{paddingLeft:0}}>
                     <span className={styles.titles} style={{margin:'10px 0'}}>扩展信息</span>
                    </div>
                    <div className={styles.extend_title}>
                      <div className={styles.extend_property}>属性名称</div>
                    </div>
                    {info && info.length > 0 && (
                      <div className={styles.list}>
                        {/* 标题行 */}
                        <div className={styles.design}>
                          {info[0]&&info[0].length>0&&info[0].map((item) => (
                            <div className={styles.design_item} key={item.english_name}>
                              <span style={{ color: "red" }}>
                                {item.is_required && "*"}
                              </span>
                              {item.property_name}
                            </div>
                          ))}
                        </div>
                        <Form
                          form={form}
                          disabled={true}
                          className={info.length>4?styles.title_main_scroll: styles.title_main}
                        >
                          {info.map((item, index) => (
                            <div key={item[0].colorId}>
                              <div className={styles.form_color}> {item[0].color}</div>
                              <Form.List name={item[0].colorId} s>
                                {() =>
                                  item.map((items) => (
                                    <div
                                      key={items.english_name}
                                      className={styles.main_input}
                                    >
                                      {items.edit_method == "text" && (
                                        <Form.Item
                                         disabled
                                          name={[items.english_name]}
                                          className={styles.main_item}
                                        >
                                          <Input
                                            bordered={false}
                                            style={{ width: "200px", display: "block",color:'black',textAlign:'center' }}
                                          />
                                        </Form.Item>
                                      )}
                                      {(items.edit_method == "single" ||
                                        item.edit_method == "multiple") && (
                                        <Form.Item
                                        disabled
                                          name={[items.english_name]}
                                          className={styles.main_item}
                                        >
                                          <Select
                                            bordered={false}
                                            style={{ width: "120px", display: "block",color:'black',textAlign:'center'  }}
                                            allowClear
                                            fieldNames={{
                                              label: "dict_name",
                                              value: "dict_key",
                                            }}
                                            options={items.value_list}
                                            mode={
                                              item.edit_method === "multiple" && "multiple"
                                            }
                                          />
                                        </Form.Item>
                                      )}
                                    </div>
                                  ))
                                }
                              </Form.List>
                            </div>
                          ))}
                        </Form>
                      
                      </div>
                    )}
                  </section> : 
                <div>
                  <div className={styles.total_title}>
                    <span className={styles.titles}>扩展信息</span>
                  </div>
                    <div className={styles.public_info}>
                      
                  <Form
                    layout="inline"
                    className={styles.public_info}
                    labelCol={{
                          style: { width: '160px' }
                      }}
                    form={Lucenform}
                  >
              {info.length>0&&info[0].map((ele) => (
                <div key={ele.english_name} className={styles.publicsection}>
                  {ele.edit_method == "text" && (
                    <Form.Item
                      labelAlign="right"
                      name={[ele.english_name]}
                      
                      rules={[
                        {
                          required: ele.is_required,
                          message: `请输入${ele.property_name}`,
                        },
                      ]}
                      label={ele.property_name}
                      className={styles.main_item}
                      disabled
                    >
                      <Input bordered={false} style={{color:'black'}} disabled  />
                    </Form.Item>
                  )}
                  {(ele.edit_method == "single" ||
                    ele.edit_method == "multiple") && (
                    <Form.Item
                      name={[ele.english_name]}
                      disabled
                      rules={[
                        {
                          required: ele.is_required,
                          message: `请输入${ele.property_name}`,
                        },
                      ]}
                      className={styles.main_item}
                    >
                      <Select
                        style={{color:'black'}}
                        allowClear
                        bordered={false}
                        disabled
                        fieldNames={{
                          label: "dict_name",
                          value: "dict_key",
                        }}
                        // placeholder="请选择"
                        options={ele.value_list}
                        mode={ele.edit_method === "multiple" && "multiple"}
                      />
                    </Form.Item>
                  )}
                </div>
              ))}
            </Form>
                    

                  </div>

                  <div className={styles.total_title}>
                    <span className={styles.titles}>SKU</span>
                  </div>

                  <div className={styles.public_info}>    
                    <section className={styles.publicsection} style={{width: '70%'}}>
                      <span className={styles.publlictitle}>
                        <span className={styles.required}>*</span>光度：
                      </span>
                      <span style={{display: 'inline-block', width: '65%', verticalAlign: 'middle'}}>
                        {detailsData && detailsData.degrees.length !== 0 ? (
                          detailsData.degrees.map((item, index) => {
                            if (item) {
                              return (
                                <span key={index}>{item + '/'}</span>
                              )
                            } else {
                              return '--'
                            }
                          })
                        ) : '--'}
                      </span>
                    </section>
                        </div>
                </div>
              }
              
            </span>
            : (
              <span>
                <div className={styles.total_title}
                  style={{ display: detailsData && detailsData.extend_propertys.length !== 0 ? 'block' : 'none'}} >
                  <span className={styles.titles}>扩展信息</span>
                </div>
                <div className={styles.public_info}>
                  {detailsData &&
                detailsData.extend_propertys &&
                  detailsData.extend_propertys.length !== 0
                    ? detailsData.extend_propertys.map((item, index) => {
                      if (item.property_type === 'Extend') {
                        return (
                          <section key ={index} className={styles.publicsection}>
                            <span className={styles.publlictitle} style={{float: 'left'}}><span className={styles.required} style={{display: item.is_required === 1 ? 'inline-block' : 'none'}}>*</span>{item.property_name}：</span>
                            {(item.property_name === '是否高散光高度数' || item.property_name === '材质是否支持记忆功能' || item.property_name === '抗UV' || item.property_name === '是否支持渐近多焦') ? (
                              <span style={{ display: 'flex', flexWrap: 'wrap' }} >
                                {item.extend_value ? item.extend_value === 1 ? '是' : '否' : '-'}
                              </span>
                            )
                              : <span style={{display: 'flex', flexWrap: 'wrap'}} >
                                {item.extend_value ? item.extend_value : '-'}
                              </span>
                            }

                          </section>
                        )
                      }
                    })
                    : null}
                </div>

                <div className={styles.total_title}
                  style={{ display: detailsData && detailsData.sku_propertys.length !== 0 ? 'block' : 'none'}}>
                  <span className={styles.titles}>SKU</span>
                </div>

                <div style={{display: 'flex', flexWrap: 'wrap', width: '100%', position: 'relative', paddingLeft: '13%'}}>
                  {detailsData && detailsData.sku_propertys && detailsData.sku_propertys.length !== 0 ? (
                    detailsData.sku_propertys.map((item, index) => {
                      if (item.property_type === 'SKU') {
                        return (
                          <section key ={index} className={styles.publicsection}>
                            <span className={styles.publlictitle} style={{float: 'left'}}><span className={styles.required} style={{display: item.is_required === 1 ? 'inline-block' : 'none'}}>*</span>{item.property_name}：</span>
                            <span style={{display: 'flex', flexWrap: 'wrap'}}>
                              {item.sku_value ? (
                                item.sku_value.map((item2, index2) => {
                                  if (item2) {
                                    return <span key={index2}>{item2 !== '' ? item2 + '/' : item2}</span>
                                  } else {
                                    return '--'
                                  }
                                })

                              ) : '-'}
                            </span>
                          </section>
                        )
                      }
                    })
                  ) : null}
                </div>
              </span>
            )}
        </div>

      </div>
    </div>
  )
}
export default CommodityInformation



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/newproductdetails/commodity-information.js